import React from 'react'
import { Footer as _Footer } from 'mds-web-ui'
import { ActiveLink } from 'mds-web-ui/components/Link/GatsbyLink'

export const Footer = ({ ...props }) => {
  return (
    <_Footer
      px={[24, 5]}
      maxWidth={null}
      currentSite="home"
      {...props}
      LinkComponent={ActiveLink}
    />
  )
}
